"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetSitemapResponse = exports.SitemapPage = exports.SitemapChangeFrequency = exports.PageUris = void 0;
var typebox_1 = require("@sinclair/typebox");
var pagination_1 = require("./pagination");
exports.PageUris = typebox_1.Type.Object({
    "en": typebox_1.Type.String(),
    "en-GB": typebox_1.Type.String(),
    "fr": typebox_1.Type.String(),
    "de": typebox_1.Type.String(),
    "es": typebox_1.Type.String(),
    "pt": typebox_1.Type.String(),
    "it": typebox_1.Type.String(),
    "ru": typebox_1.Type.String(),
    "ja": typebox_1.Type.String(),
    "zh": typebox_1.Type.String(),
}, {
    title: "PageUris",
});
// https://www.sitemaps.org/protocol.html#changefreqdef
exports.SitemapChangeFrequency = typebox_1.Type.Union([
    typebox_1.Type.Literal("always"),
    typebox_1.Type.Literal("hourly"),
    typebox_1.Type.Literal("daily"),
    typebox_1.Type.Literal("weekly"),
    typebox_1.Type.Literal("monthly"),
    typebox_1.Type.Literal("yearly"),
    typebox_1.Type.Literal("never"),
], { title: "SitemapChangeFrequency" });
exports.SitemapPage = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    uris: exports.PageUris,
    dateModified: typebox_1.Type.String({ format: "date" }),
    changeFrequency: typebox_1.Type.Optional(exports.SitemapChangeFrequency),
    priority: typebox_1.Type.Optional(typebox_1.Type.Number()),
}, { title: "SitemapPage" });
exports.GetSitemapResponse = typebox_1.Type.Object({
    type: typebox_1.Type.Literal("sitemap"),
    data: typebox_1.Type.Object({
        pages: typebox_1.Type.Array(exports.SitemapPage),
        meta: pagination_1.PaginationMeta,
    }, { title: "GetSitemapResponse.data" }),
}, { title: "GetSitemapResponse" });
